import { sql } from "drizzle-orm";
import { integer, sqliteTable, text } from "drizzle-orm/sqlite-core";

export * from "./auth";

// Compile runs table for TypeScript compilation analysis
// Schema matches apps/honcpiler-migration/migrations/0001_initial_schema.sql
export const compileRuns = sqliteTable("compile_runs", {
  compileId: text("compile_id").primaryKey(),
  timestamp: integer("timestamp"),
  userId: text("user_id"),
  projectId: text("project_id"),
  honcVersion: text("honc_version"),
  errorCount: integer("error_count"),
  errorsJson: text("errors_json"), // JSON string of TypeScript errors
  r2Prefix: text("r2_prefix"), // R2 storage prefix for input files
  legacy: integer("legacy"), // 1=true, 0=false (matches migration exactly)
});

// Usage snapshots table for analytics data
export const usageSnapshots = sqliteTable("usage_snapshots", {
  id: text("id")
    .primaryKey()
    .$defaultFn(() => crypto.randomUUID()),
  snapshotDate: integer("snapshot_date", { mode: "timestamp" }).notNull(),

  // User metrics
  usersCreatedToday: integer("users_created_today").notNull().default(0),
  usersCreatedThisWeek: integer("users_created_this_week").notNull().default(0),
  usersCreatedThisMonth: integer("users_created_this_month")
    .notNull()
    .default(0),
  totalUsers: integer("total_users").notNull().default(0),

  // Chat activity metrics (chats === projects in the current implementation)
  chatsCreatedToday: integer("chats_created_today").notNull().default(0),
  chatsCreatedThisWeek: integer("chats_created_this_week").notNull().default(0),
  chatsCreatedThisMonth: integer("chats_created_this_month")
    .notNull()
    .default(0),
  totalChats: integer("total_chats").notNull().default(0),

  // Active user metrics
  activeUsersToday: integer("active_users_today").notNull().default(0),
  activeUsersThisWeek: integer("active_users_this_week").notNull().default(0),

  createdAt: integer("created_at", { mode: "timestamp" })
    .notNull()
    .default(sql`(unixepoch())`),
});

// Type exports for use in the worker
export type CompileRun = typeof compileRuns.$inferSelect;
export type NewCompileRun = typeof compileRuns.$inferInsert;
export type UsageSnapshot = typeof usageSnapshots.$inferSelect;
export type NewUsageSnapshot = typeof usageSnapshots.$inferInsert;
